import type { VideoProps } from 'fitify-ui-onboarding/src/types/ui'

import { ALL_VIDEOS, DEFAULT_VIDEO_VARIANT } from 'data/videos'
import type {
  VideoCategories,
  VideoCategoryPageAssets,
  VideoCategoryPages,
  VideoCategoryVariants,
  VideoDefinition,
} from 'types/videos'

type GetVideoOptions<
  TCategory extends VideoCategories,
  TVariant extends VideoCategoryVariants<TCategory>,
> = {
  variant?: TVariant | (string & {})
}

const getVideo = <
  TCategory extends VideoCategories,
  TVariant extends VideoCategoryVariants<TCategory>,
  TPages extends VideoCategoryPages<TCategory, TVariant>,
  TVideo extends VideoCategoryPageAssets<TCategory, TVariant, TPages>,
>(
  category: TCategory,
  page: TPages,
  videoName: TVideo,
  { variant }: GetVideoOptions<TCategory, TVariant> = {}
): VideoDefinition => {
  const resolvedVariant = (variant ?? DEFAULT_VIDEO_VARIANT) as TVariant
  return ALL_VIDEOS[category][resolvedVariant][page][
    videoName
  ] as VideoDefinition
}

export const processVideoDefinition = (
  videoDefinition: VideoDefinition
): VideoProps => {
  return {
    src: videoDefinition.src,
  }
}

export const getVideoProps = <
  TCategory extends VideoCategories,
  TVariant extends VideoCategoryVariants<TCategory>,
  TPages extends VideoCategoryPages<TCategory, TVariant>,
  TVideo extends VideoCategoryPageAssets<TCategory, TVariant, TPages>,
>(
  category: TCategory,
  page: TPages,
  videoName: TVideo,
  options: GetVideoOptions<TCategory, TVariant> = {}
): VideoProps => {
  const videoDefinition = getVideo(category, page, videoName, options)
  return processVideoDefinition(videoDefinition)
}
